import React, { useState, useEffect, useContext } from "react";
import BranchContext from "../context/branch";
import Truckwms from "./truckwms";
import {
  GetprivilegePage,
  weightperhour,
  getMonitorECE,
  weightdetail,
  getWoodchipSumary,
} from "../../services/wms";
import moment from "moment";
import DatePicker from "react-datepicker";
import Header from "../wms/header";
import Headerproduct from "../wms/headerproduct";
import Renderdata from "../wms/card";
import ModalDetial from "../wms/modaldetail";
import Headerreport from "../wms/headerreport";
import ReportCreate from "../chart/reportCreator";
import { toast } from "react-toastify";
import Reportwms from "./reportwms";
import ReportToProduce from "./reporttoproduce";
import HeaderSelect from "./headerreport";

const Inoutmonitor = (props) => {
  const [branchid, setbranchid] = useState(0);
  const [reportId, setReportId] = useState("1");
  const [reportId2, setReportId2] = useState("0");
  const [proid, setproid] = useState(0);
  const [Id, setId] = useState("");
  const [data, setData] = useState({});
  const [startDate, setstartDate] = useState(new Date());
  const [endDate, setendDate] = useState(new Date());
  const [queuelist, setqueuelist] = useState([]);
  const { currentBranch } = useContext(BranchContext);
  const [isOpen, setisOpen] = useState(false);
  const [list, setlist] = useState([]);
  const [perhour, setperhour] = useState([]);
  const [onProgress, setonProgress] = useState(false);
  const [onsubProgress, setonsubProgress] = useState(false);
  const [ckPermit, setckPermit] = useState(false);

  const [total, settotal] = useState({
    overtime: 0,
    waiting: 0,
    normal: 0,
    weightlog: 0,
    weightchip: 0,
    weightbark: 0,
  });

  useEffect(() => {
    if (!currentBranch) return;
    if (branchid == 0) return;
    if (reportId !== "1") return;

    const loadData = async () => {
      const { data: result } = await getMonitorECE(
        branchid,
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );

      if (result) {
        setqueuelist(result);
      }
    };
    loadData();
  }, [currentBranch, branchid, startDate, reportId]);
  //  console.log("setqueuelist",queuelist)
  useEffect(() => {
    if (!currentBranch) return;
    if (branchid == 0) return;
    if (reportId !== "1") return;

    const loadData = async () => {
      setonProgress(true);
      const { data: result } = await getWoodchipSumary(
        branchid,
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD"),
        proid
      );

      if (result.status === "success") {
        setonProgress(false);
        settotal({
          overtime: result.data.overtime,
          waiting: result.data.waiting,
          normal: result.data.normal,
          weightlog: result.data.weightlog,
          weightchip: result.data.weightchip,
          weightbark: result.data.weightbark,
        });
      } else {
        setonProgress(false);
      }
    };
    loadData();
  }, [currentBranch, branchid, startDate, reportId, proid]);

  //console.log(total)
  useEffect(() => {
    if (!currentBranch) return;
    if (branchid == 0) return;
    if (reportId !== "2") return;

    const loadData = async () => {
      setonProgress(true);
      const { data: result } = await weightperhour(
        branchid,
        moment(startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
      );

      if (result) {
        setonProgress(false);
        setperhour(result);
      }
    };
    loadData();
  }, [currentBranch, branchid, startDate, reportId]);

  useEffect(() => {
    if (!currentBranch) return;
    if (branchid == 0) return;
    setonProgress(true);
    const loadData = async () => {
      const { data: result } = await weightdetail(Id);

      if (result) {
        setonProgress(false);
        setlist(result);
      }
    };
    loadData();
  }, [currentBranch, branchid, Id]);

  useEffect(() => {
    if (!currentBranch) return;
    if (currentBranch._id == "0" || currentBranch._id == "") return;
    const loadPrivilege = async () => {
      const { data: result } = await GetprivilegePage(
        "woodchipmonitor",
        currentBranch._id
      );
      if (result.status === "success") {
        setckPermit(true);
      } else if (result.status === "error") {
        toast.error(result.message);
        if (result.message === "invalid token") {
          const urlGoBack = "logout";
          setTimeout(props.history.replace(urlGoBack), 1000);
        }
      }
    };
    loadPrivilege();
  }, [currentBranch, branchid]);

  const handleChange = (event) => {
    setbranchid(event);
  };
  const handleReportChange = (event) => {
    setReportId(event);
    if (event == 4) {
      setReportId2(0);
    }
  };
  const handleProductChange = (event) => {
    setproid(event);
  };
  const handleChangStartDate = (event) => {
    setstartDate(event);
  };
  const handleChangEndDate = (event) => {
    setendDate(event);
  };

  const handleonClick = (event) => {
    setisOpen(true);
    setId(event);
  };
  const handleConfirm = () => {
    setisOpen(false);
  };
  const handleCancel = () => {
    setisOpen(false);
  };

  useEffect(() => {
    if (!perhour || !currentBranch) return;
    const chart = () => {
      let phour = [];
      let AmountA = [];
      let AmountB = [];
      for (const dataObj of perhour) {
        phour.push(dataObj.hour);
        AmountA.push(parseInt(dataObj.amount));
        AmountB.push(parseInt(dataObj.amount_out));
      }
      const data = {
        series: [
          { name: "ชั่งเข้า", data: AmountA },
          { name: "ชั่งออก", data: AmountB },
        ],
        yLabels: phour,
        headers: "ปริมาณรถตามช่วงเวลา",
        type: "bar",
        stacked: true,
      };
      setData(data);
    };
    chart();
  }, [perhour, currentBranch]);

  //console.log(perhour);
  const disabledmenu = (event) => {
    setonProgress(event);
  };
  const disabledsubmenu = (event) => {
    setonProgress(event);
    setonsubProgress(event);
  };
  const handleSelectReport = (event) => {
    setReportId2(event);
  };
  if (!(currentBranch._id == "501")) {
    return <></>;
  }

  if (!ckPermit) return <></>;
  return (
    <>
      <ModalDetial
        isOpen={isOpen}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        list={list}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-auto">
            <i>
              วันที่ 
            </i>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
               className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={startDate}
                onChange={handleChangStartDate}
              />
            </div>
          </div>
          <div className="col-auto">
            <i>
              ถึงวันที่ 
            </i>

            <div className="mt-1" style={{ marginTop: 20, marginBottom: 20 }}>
              <DatePicker
                className="datepicker-default form-control"
                todayButton="Today"
                dateFormat="dd/MM/yyyy"
                selected={endDate}
                onChange={handleChangEndDate}
              />
            </div>
          </div>
          <div className="col-auto">
            <i>
              ประเภทรายงาน 
            </i>
            <div className="mt-1 " >
              <Headerreport
                onChange={handleReportChange}
                disabled={onProgress}
              />
            </div>
          </div>
        </div>

        {reportId && (reportId == 1 || reportId == 2) && (
          <div className="row">
            <div className="col-auto">
              <i>
                พื้นที่ 
              </i>
              <div
                className="mt-1 "
                style={{ marginTop: 20, marginBottom: 20 }}
              >
                <Header onChange={handleChange} disabled={onsubProgress} />
              </div>
            </div>
          </div>
        )}
        {reportId && reportId == 1 && (
          <div className="row">
            <div className="col-auto">
              <div
                className="mt-1 "
                style={{ marginTop: 20, marginBottom: 10 }}
              >
                <Headerproduct
                  onChange={handleProductChange}
                  disabled={onsubProgress}
                />
              </div>
            </div>

            <div className="col-auto mb-2 mt-2">
              <span
                className="badge  bg-warning text-dark"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ชั่งเข้า"} {total.waiting}
              </span>
            </div>

            <div className="col-auto mb-2 mt-2">
              <span
                className="badge bg-success"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ชั่งออก"} {total.normal}
              </span>
            </div>

            <div className="col-auto mb-2 mt-2">
              <span
                className="badge bg-danger"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ชั่งออก เกิน 2ชม."} {total.overtime}
              </span>
            </div>

            <div className="col-auto mb-2 mt-2">
              <span
                className="badge bg-primary"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ไม้ท่อนรับเข้า"} {total.weightlog}
              </span>
            </div>

            <div className="col-auto mb-2 mt-2">
              <span
                className="badge bg-warning text-dark"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"ไม้สับส่งออก"} {total.weightchip}
              </span>
            </div>

            <div className="col-auto mb-2 mt-2">
              <span
                className="badge  bg-danger"
                style={{ fontSize: "13px", cursor: "pointer" }}
              >
                {"เปลือกส่งออก"} {total.weightbark}
              </span>
            </div>
          </div>
        )}

        {reportId && reportId == 1 && (
          <Renderdata
            list={queuelist}
            product={proid}
            handleonClick={handleonClick}
            disabled={disabledsubmenu}
          />
        )}

        {reportId && reportId == 2 && (
          <div className="col-12">
            <div className="mt-1">
              {data.series !== undefined && (
                <ReportCreate
                  data={data}
                  palette="palette1"
                  labelposition="top"
                  onclick={handleonClick}
                />
              )}
            </div>
          </div>
        )}

        {reportId && reportId == 3 && (
          <div>
            <Truckwms
              startDate={startDate}
              endDate={endDate}
              disabled={disabledmenu}
            />
          </div>
        )}

        {reportId && reportId == 4 && (
          <div className="m-2">
            <HeaderSelect
              onChange={handleSelectReport}
              disabled={onsubProgress}
            />
          </div>
        )}
        {reportId && reportId == 4 && reportId2 && reportId2 == 1 && (
          <div>
            <Reportwms
              startDate={startDate}
              endDate={endDate}
              disabled={disabledsubmenu}
            />
          </div>
        )}

        {reportId && reportId == 4 && reportId2 && reportId2 == 2 && (
          <div>
            <ReportToProduce
              startDate={startDate}
              endDate={endDate}
              disabled={disabledsubmenu}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Inoutmonitor;
